/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_TypeInputs */

const en_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Type`)
};

const fr_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de tâche`)
};

const de_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art der Stelle`)
};

const it_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di lavoro`)
};

const ru_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип работы`)
};

const es_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de trabajo`)
};

const zh_cn2_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`职位类型`)
};

const ja_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`職種`)
};

const hi_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी का प्रकार`)
};

const pt_pt2_job_type = /** @type {(inputs: Job_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de vaga`)
};

/**
* | output |
* | --- |
* | "Job Type" |
*
* @param {Job_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_type = /** @type {((inputs?: Job_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_job_type(inputs)
	if (locale === "de") return de_job_type(inputs)
	if (locale === "it") return it_job_type(inputs)
	if (locale === "ru") return ru_job_type(inputs)
	if (locale === "es") return es_job_type(inputs)
	if (locale === "zh-CN") return zh_cn2_job_type(inputs)
	if (locale === "ja") return ja_job_type(inputs)
	if (locale === "hi") return hi_job_type(inputs)
	if (locale === "pt-PT") return pt_pt2_job_type(inputs)
	return en_job_type(inputs)
});